import { useTranslation } from 'react-i18next'
import { KRW_PER_USD } from '../constants/plan'
import type { DownloadKey, UserLevel } from '../constants/plan'

/** 요금제 화면·내 정보 화면이 공유하는 표시 문구(등급 이름, 금액 표기, 다운로드 정책). 금액은 항상 원화이고 영어 화면에서만 USD 환산을 덧붙인다. */
export function usePlanText() {
  const { t, i18n } = useTranslation()
  const isEn = !!(i18n.resolvedLanguage ?? i18n.language)?.toLowerCase().startsWith('en')
  const locale = isEn ? 'en-US' : 'ko-KR'

  const num = (n: number) => n.toLocaleString(locale)
  const usd = (krw: number) => `$${Math.round(krw / KRW_PER_USD).toLocaleString('en-US')}`

  return {
    isEn,
    num,
    levelLabel: (level: UserLevel) => t(`plan.level.${level}`),
    description: (level: UserLevel) => t(`plan.desc.${level}`),
    downloadLabel: (key: DownloadKey) => t(`plan.download.${key}`),
    /** 서버가 내려주는 다운로드 정책 문구('미제공'/'종량제')를 번역 */
    downloadPolicy: (raw: string) => t(`plan.download.${raw === '미제공' ? 'none' : 'payg'}`),
    /** 월 요금: 0원이면 "무료/Free" */
    monthlyFee: (fee: number) => {
      if (fee === 0) return t('plan.fee.free')
      const base = t('plan.fee.perMonth', { amount: num(fee) })
      return isEn ? `${base} ${t('plan.fee.usdApprox', { usd: usd(fee) })}` : base
    },
    /** 일반 금액: 0원이면 "없음/None" */
    krw: (amount: number) =>
      amount === 0 ? t('plan.fee.none') : t('plan.fee.amount', { amount: num(amount) }),
  }
}
